export default [
  {
    path: '/',
    name: 'Login',
    meta: { requiresAuth: false },
    component: () => import('@/components/functions/Auth/PgLogin')
  },
  {
    path: '/Top',
    name: 'Top',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/Top/TopIndex')
  },
  {
    path: '/Home',
    name: 'Home',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/A0001Admin/A0001AdminIndex')
  },
  {
    path: '/D0101Demo',
    name: 'D0101Demo',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/D0101Demo/D0101DemoIndex')
  },
  {
    path: '/ManageFrame',
    name: 'ManageFrame',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0005Frame/M0005FrameIndex')
  },
  {
    path: '/Products',
    name: 'Products',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0002Product/M0002ProductIndex')
  },
  {
    path: '/Purchase',
    name: 'Purchase',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/Purchase/PurchaseIndex')
  },
  {
    path: '/PurchaseDetail/:id',
    name: 'PurchaseDetail',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/Purchase/PurchaseDetail')
  },
  {
    path: '/Category',
    name: 'Category',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/P0102Category/P0102CategoryIndex')
  },
  {
    path: '/FrameType',
    name: 'FrameType',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0405FrameType/M0405FrameTypeIndex')
  },
  {
    path: '*',
    redirect: '/'
  }
]
